import * as React from 'react'

const SvgComponent = (props: any) => (
  <svg width={13} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'icons/small/loading'}</title>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M11.862.036a.25.25 0 0 0-.272.053l-1.521 1.505A5.937 5.937 0 0 0 6.008 0a6 6 0 0 0-5.5 3.6 1 1 0 0 0 1.833.8A4 4 0 0 1 6.008 2a3.954 3.954 0 0 1 2.636 1L6.949 4.681a.251.251 0 0 0-.06.259.248.248 0 0 0 .209.166l4.64.514h.028a.248.248 0 0 0 .25-.25V.267a.251.251 0 0 0-.154-.231ZM.154 11.964c.031.014.066.02.1.019a.251.251 0 0 0 .176-.072l1.521-1.5A5.937 5.937 0 0 0 6.008 12a6 6 0 0 0 5.5-3.6 1 1 0 0 0-1.833-.8A4 4 0 0 1 6.008 10a3.954 3.954 0 0 1-2.636-1l1.7-1.677a.251.251 0 0 0 .06-.259.248.248 0 0 0-.209-.166L.278 6.38a.27.27 0 0 0-.195.061.252.252 0 0 0-.083.187v5.105c0 .101.06.192.154.231Z" />
    </g>
  </svg>
)

export default SvgComponent
